/**
 * Handles notify me button for PLP's (Supported only by favorites and BI best sellers)
 *
 * @module plpNotifyMe
 */

import $ from 'jquery';
import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';

export const PLUGIN_NAME = 'plpNotifyMe';

const notifyMe = ($el) => {
    const data = $.param({
        code : $el.data('code'),
        sizeSelected : $el.data("sizeSelected")
    });

    $.modal({
        url : window.rcProps.backInStockSpecialOrderHref,
        data: data,
        triggerOpen: true,
        onComplete: function(){
            $('.js-progressive-button').progressiveButton();
        }
    });
}

/**
 * Notify Me Functionality for PLP (Supported on Favorites/BI Best Seller Page atm)
 *
 * @param {jQuery} el - targeting the element of the plp list
 * @param {Object} options - Options used for wiring up the sizeSelection
 * @see DEFAULTS
 */
export default function plpNotifyMe(el, options = {}) {
    const $el = $(el);

    $el.on('click', (e) => {
        e.preventDefault();
        notifyMe($el);
    });
}

registerJQueryPlugin(PLUGIN_NAME, plpNotifyMe);


// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/notify-me.js